<template>
  <div class="pass-login-wrap" :class="{fixed: fixed}">
    <div class="beast-login-warp login pass-login" v-show="!forgetShow">
      <img v-if="showClose" class="close" @click="close" src="https://img.thebeastshop.com/app/4.0/icon/icon-back.png">
      <div class="login-head pass-login">
        <p class="title" >密码登录</p>
      </div>
      <div class="login-main pass-login">
        <div class="type">
          <div class="item" :class="{active: loginType=='mobile' }" @click="changeLoginType('mobile')">手机号</div>
          <div class="item" :class="{active: loginType=='email' }" @click="changeLoginType('email')">邮箱</div>
        </div>
        <div class="input-warp">
          <div class="input-group" >
            <div v-show="loginType=='mobile'">
              <div class="input-row">
                <div class="phone-area" @click="selectCountry">
                  {{ country.country_code }}
                </div>
                <i class="split"></i>
                <div class="phone-input">
                  <input type="text" v-model="mobile" placeholder="请输入手机号"
                    @blur="blur"
                    @focus="focus">
                </div>
              </div>
            </div>
            <div v-show="loginType=='email'">
              <div class="input-row">
                <input type="text" v-model="email" placeholder="请输入邮箱"
                  @blur="blur"
                  @focus="focus">
              </div>
            </div>
            <div class="input-row">
              <i class="input-del" @click="delPass" v-show="password"></i>
              <input type="password" v-model="password" placeholder="请输入密码"
                @blur="blur"
                @focus="focus">
            </div>
          </div>
        </div>
      </div>
      <div class="login-tips">
        <span class="error">{{ error }}</span> <span @click="forget" class="to-forget">忘记密码</span>
      </div>
      <div class="login-btn-wrap">
        <div @click="login" class="login-btn-pass">
          登录
        </div>
      </div>
     
      <div class="login-others pass-login">
        <div class @click="close">快捷登录注册</div>
      </div>
      <div class="bg"><img src="https://img.thebeastshop.com/app/4.0/icon/login/login-bg.png" /></div>
    </div>
    
    <forget v-if="forgetShow" @forget="forgetClose" @cancel="forgetClose"></forget>
  </div>
</template>

<script>
import track from '@/track'
import _country from './data/country.js'
import Vue from 'vue'
import Select from '@/plugins/select'
import Forget from './forget.vue'
import api from './api.js'
Vue.use(Select)
export default {
  components:{
    Forget
  },
  data (){
    return {
       loginType: 'mobile',
       countryIndex: 0,
       error: '',
       mobile: '',
       email: '',
       password: '',
       forgetShow: false,
       fixed: false
    }
  },
  props: {
    showClose: {
      default: true
    }
  },
  computed: {
    country: function(){
      return _country[this.countryIndex]
    }
  },
  methods: {
    changeLoginType: function(type){
      track({
        name: `login-${type}`
      })
      this.loginType = type
      this.password = ''
      // console.log(type);
    },
    selectCountry: function(){
      track({
        name: 'areaCode'
      })
      this.$select(_country.map((item) => {
        return item.country_name_cn
      }))
      .then((data) => {
        this.countryIndex = data
      })
      .catch(()=>{
        // console.log('select-cancel');
      })
    },
    close: function (){
      track({
        name: 'close'
      })
      this.$emit('cancel')
    },
    register: function (){
      track({
        name: 'login-register'
      })
      this.$emit('register')
    },
    forget: function(){
      track({
        name: 'login-forget'
      })
      this.forgetShow = true
    },
    forgetClose: function(){
      this.forgetShow = false
    },
    delPass () {
      this.password = ''
    },
    login: function (){
      track({
        name: 'login-login'
      })
      let _json = {
        principal: '',
        credential: '',
        authType: this.loginType.toUpperCase()
      }
      if(this.loginType == 'mobile'){
        if(this.mobile.length!=11){
          this.$alert("请输入正确的手机号")
          return
        }
        _json.principal = `${this.country.country_code}-${this.mobile}`
      }else{
        if(this.email==''){
          this.$alert("请输入邮箱")
          return
        }
        _json.principal = this.email
      }
      if(this.password == ''){
        this.$alert("请输入密码")
        return
      }
      _json.credential = this.password
      api.login(_json)
      .then(({code, data}) => {
        this.$emit('login', data.member)
      })
      .catch(({ message }) => {
        this.$alert(message)
        track({
          name: 'login-failed',
          attrs: {
            message
          }
        })
      })
    },

    blur () {
      this.fixed = false
    },

    focus () {
      this.fixed = true
    }
  }
}
</script>

<style lang="stylus">
  @import './pass-login.styl'
</style>



// WEBPACK FOOTER //
// pass-login.vue?6243e60c